// Currency formatting utility
const SYMBOLS = {
  NGN: '₦',
  USD: '$',
  EUR: '€',
  GBP: '£',
};

const LOCALES = {
  NGN: 'en-NG',
  USD: 'en-US',
  EUR: 'de-DE',
  GBP: 'en-GB',
};

export const formatCurrency = (amount, currency = 'NGN') => {
  const symbol = SYMBOLS[currency] || '₦';
  const locale = LOCALES[currency] || 'en-NG';
  const value = Number(amount) || 0;
  return `${symbol}${value.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const getCurrencySymbol = (currency = 'NGN') => SYMBOLS[currency] || '₦';

export const CURRENCY_SYMBOL = '₦';
export const CURRENCY_CODE = 'NGN';
